import { connect } from 'react-redux';
import { actions } from "../../UserProfileManager/UserProfileAction";
import UserRoleProfile from './UserRoleProfile';

const mapStateToProps = (state) => {
  const userRoles = state.userProfileReducer.userRoles || {};
  const userProfile = state.userProfileReducer.userProfile || {};
  return {
    userRoles,
    userProfile,
  };
};

export default connect(mapStateToProps, actions)(UserRoleProfile);